import { useQueryClient, useMutation } from 'react-query'
import { type PersonType } from '../../../../enumns/personType'
import { type ExpertDomain } from '../../../../types/domain/expert-domain'
import { api } from '../../../api'

const changeExpertType = async (
  id: number,
  personType: PersonType
): Promise<ExpertDomain> => {
  const response = await api.patch<ExpertDomain>(`/experts/${id}/person-type`, { personType })
  return response.data
}

export const useExpertPersonTypeMutation = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn ({ id, personType }: { id: number, personType: PersonType }) {
      return changeExpertType(id, personType)
    },
    onSuccess (data: ExpertDomain) {
      queryClient.setQueryData(['expert', data.id], data)
    }
  })
}
